import * as Components from './components';
import * as Directives from './directives';

export default function plugin(Vue) {
    Object.keys(Components).forEach((key) => {
        Vue.component(key, Components[key])
    });

    Object.keys(Directives).forEach((key) => {
        Vue.directive(key, Directives[key])
    })
}


// WEBPACK FOOTER //
// ./src/baseComponents/index.js